import React from 'react';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import logo from '../../image/logos-24.svg'
import logoDark from '../../image/logos-24Dark.svg'
import { useTheme } from '@mui/material'

function Loading({open}) {
    const theme = useTheme();
    return (
        <Backdrop
            sx={{ color: 'var(--main-bg-color)', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
        >
            <CircularProgress size={140} color="inherit" />
            <Box
                sx={{
                top: 0,
                left: 13,
                bottom: 10,
                right: 0,
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                }}
            >
                <img
                src={theme !== 'dark' ? logo : logoDark}
                height="150"
                style={{height: 150}}
                alt="logo"
                />
            </Box>
        </Backdrop>
    );
}

export default Loading;